import { PageActions } from '@e3dc-react/shell/State/App/AppModel'
import React from 'react'

export interface PageActionsContextProps {
  dispatchPageActions?: (value: PageActions) => void
  pageActions?: PageActions
}

const PageActionsContext = React.createContext<PageActionsContextProps>({})

export default PageActionsContext
